import { makeStyles } from '@material-ui/styles';
import dayjs from 'dayjs';

import '../../assets/css/print.css';

const Logo = require('../../assets/images/logo-full.png').default;

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0
    },
    container: {
        display: 'block',
        pageBreakInside: 'avoid',
        marginBottom: '6vh'
    },
    logo: {
        alignSelf: 'center',
        maxHeight: 80
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 25
    },
    description: {
        display: 'flex',
        flexDirection: 'column'
    },
    ticketContainer: {
        pageBreakInside: 'avoid',
        marginBottom: 20
    },
    ticketHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#F2F2F2',
        padding: 8,
    },
    tableContainer: {
        overflowX: 'auto',
        width: '100%'
    },
    summaryTable: {
        width: '100%',
        borderCollapse: 'collapse',
        overflow: 'hidden'
    },
    tableRow: {
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#e0e0e0'
    },
    summaryHeaderText: {
        textAlign: 'center',
        whiteSpace: 'nowrap',
        padding: 4,
        fontWeight: 'bold'
    },
    summaryText: {
        padding: 4,
        textAlign: 'center',
        whiteSpace: 'nowrap'
    }
}));

const TicketMasterToPrintDetail = ({ data }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            {
                data.map(master =>
                    <div key={master.idticket_master} className={classes.container}>
                        <div className={classes.header}>
                            <div className={classes.description}>
                                <span><b>{`Sede: `}</b>{master.sede.name}</span>
                                <span><b>{`Date: `}</b>{dayjs(master.date).format('MM/DD/YYYY')}</span>
                                <span><b>{`Master ticket: `}</b>{master.code}</span>
                                <span><b>{`Total: `}</b>{`$ ${master.total}`}</span>
                            </div>

                            <div className={classes.description}>
                                <span><b>{`Supplier: `}</b>{master.supplier.name}</span>
                                <span><b>{`Land: `}</b>{master.land.name}</span>
                                <span><b>{`Location: `}</b>{master.location.name}</span>
                                <span><b>{`Carrier: `}</b>{master.carrier?.name ?? 'N/A'}</span>
                            </div>

                            <img className={classes.logo} src={Logo} alt='logo cfg' />
                        </div>

                        {
                            master.tickets?.map(ticket =>
                                <div key={ticket.idticket} className={classes.ticketContainer}>
                                    <div className={classes.ticketHeader}>
                                        <span><b>{'Breakdown: '}</b>{ticket.code}</span>
                                        <span><b>{'Product: '}</b>{ticket?.product_type_ref?.product.name ?? 'N/A'}</span>
                                        <span><b>{'Type: '}</b>{ticket?.product_type_ref?.type.name ?? 'N/A'}</span>
                                        <span><b>{'Total $: '}</b>{`$ ${ticket.total}`}</span>
                                    </div>

                                    <div className={classes.tableContainer}>
                                        <table className={classes.summaryTable}>
                                            <thead>
                                                <tr className={classes.tableRow}>
                                                    <th className={classes.summaryHeaderText}>{'Item'}</th>
                                                    <th className={classes.summaryHeaderText}>{'Total qty'}</th>
                                                    <th className={classes.summaryHeaderText}>{'Price'}</th>
                                                    <th className={classes.summaryHeaderText}>{'Total'}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    ticket.detail.length
                                                        ?
                                                        ticket.detail.map(detail =>
                                                            <tr key={detail.iddetail_ticket}>
                                                                <td className={classes.summaryText}>{detail.item.name}</td>
                                                                <td className={classes.summaryText}>{detail.total_qty}</td>
                                                                <td className={classes.summaryText}>{`$ ${detail.final_price}`}</td>
                                                                <td className={classes.summaryText}>{`$ ${detail.total}`}</td>
                                                            </tr>
                                                        )
                                                        :
                                                        <tr>
                                                            <td className={classes.summaryText}>{'N/A'}</td>
                                                            <td className={classes.summaryText}>{'N/A'}</td>
                                                            <td className={classes.summaryText}>{'N/A'}</td>
                                                            <td className={classes.summaryText}>{'N/A'}</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )
                        }


                    </div>
                )
            }
        </div>
    );
}

export default TicketMasterToPrintDetail;